import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProjectsService} from '../_services/projects.service';
import {FormBuilder} from '@angular/forms';
import {ApexChart} from 'ng-apexcharts';

@Component({
    selector: 'app-task-view',
    templateUrl: './task-view.component.html',
    styleUrls: ['./task-view.component.scss']
})
export class TaskViewComponent implements OnInit, OnDestroy {
    dataLoaded = false;
    percentageLoaded = false;

    projectId: string;
    projectData: any;
    stageData: any;
    projectDataLoaded = false;
    stageId: string;
    taskId: string;

    taskData: any;
    userData: any;

    // progress bar by date
    progressBar = 0;
    barClass: string;
    spanColor: string;
    subTaskPercentage = 0;

    @ViewChild('chart') apexChart: any;
    chartOptions: any = {};

    // User Permissions
    isAllowedToEdit = false;
    isAllowedToView = false;

    // array of current user roles
    userRoles = [];
    currentUserId: string;

    // Unsubscribe
    unsubscribe = [];

    constructor(private router: Router,
                private route: ActivatedRoute,
                private modalService: NgbModal,
                private projectsService: ProjectsService,
                private fb: FormBuilder) {
    }

    ngOnInit(): void {
        const routeSub = this.route.params.subscribe(params => {
            if (params.id) {
                this.projectId = params.id;
            }
            if (params.position) {
                this.stageId = params.position;
            }
            this.taskId = params.task;
            
        });
        this.unsubscribe.push(routeSub);

        this.projectsService.getCurrentUser().subscribe( (user: any) => {
            this.currentUserId = user.id;
            this.userRoles = user.roles;

            this.checkForPermissions('Projects', this.userRoles);
        });

        this.projectsService.getTaskById(this.taskId).subscribe( (task: any) => {
            
            this.taskData = task;
            const subTasks = task.subtasks;
            let subTasksSolved = 0;
            if (subTasks && subTasks.length > 0) {
                subTasks.forEach(subTask => {
                    if (subTask.solved === true) {
                        subTasksSolved++;
                    }
                });
                this.subTaskPercentage = Math.floor(subTasksSolved * 100 / subTasks.length);
            }

            if (this.taskData.status === 'completed' && (subTasks === null || subTasks.length === 0)) {
                this.subTaskPercentage = 100;
            } else if (this.taskData.status !== 'completed' && (subTasks === null || subTasks.length === 0)) {
                this.subTaskPercentage = 0;
            }

            this.chartOptions = this.getChartOptions();

            if (this.taskData.receiverUserId !== '' && this.taskData.receiverUserId !== null) {
                this.projectsService.getUserById(this.taskData.receiverUserId).subscribe(user => {
                    
                    this.userData = user;

                    this.dataLoaded = true;
                });
            } else {
                
                this.dataLoaded = true;
            }
            this.getProgressColor();

            if (task.projectId !== '' && task.projectId !== null) {
                const projectSub = this.projectsService.getProjectById(task.projectId).subscribe( project => {
                    
                    this.projectData = project;
                    if (this.projectData.stage !== null && this.projectData.stage.length > 0) {
                        this.stageData = this.projectData.stage[this.taskData.projectStage - 1];
                        
                    }
                    this.projectDataLoaded = true;
                });
                this.unsubscribe.push(projectSub);
            }
        });

    }

    checkForPermissions(moduleName: string, rolesArray: string[]) {
        if (rolesArray.includes('ROLE_super_admin') || rolesArray.includes('ROLE_admin')) {
            this.isAllowedToEdit = true;
            this.isAllowedToView = true;
            
        } else {
            if (rolesArray.includes(`ROLE_${moduleName}Full`)) {
                this.isAllowedToEdit = true;
                this.isAllowedToView = true;
                
            } else if (rolesArray.includes(`ROLE_${moduleName}View`)) {
                this.isAllowedToEdit = false;
                this.isAllowedToView = true;
                
            }
        }
    }

    getChartOptions() {
        this.percentageLoaded = true;
        const strokeColor = 'rgba(73, 80, 250, 1)';
        const bgColor = '#ffffff';
        const textColor = '#2E2A41';
        return {
            series: [this.subTaskPercentage],
            chart: {
                type: 'radialBar',
                height: 200,
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        margin: 0,
                        size: '65%',
                    },
                    dataLabels: {
                        showOn: 'always',
                        name: {
                            show: false,
                            fontWeight: '700',
                        },
                        value: {
                            color: textColor,
                            fontSize: '30px',
                            fontWeight: '700',
                            offsetY: 12,
                            show: true,
                        },
                    },
                    track: {
                        background: bgColor,
                        strokeWidth: '100%',
                        opacity: 1,
                        startAngle: -180,
                        endAngle: 180
                    },
                },
            },
            colors: [strokeColor],
            labels: ['Progress'],
            legend: {},
            dataLabels: {},
            fill: {},
            xaxis: {},
            yaxis: {},
            states: {
                normal: {
                    filter: {
                        type: 'none'
                    }
                },
                hover: {
                    filter: {
                        type: 'none'
                    }
                },
                active: {
                    allowMultipleDataPointsSelection: false,
                    filter: {
                        type: 'none'
                    }
                }
            },
            tooltip: {},
            markers: {},
        };
    }

    // setam culoarea progress bar-ului cu due date si span-ul de sub el
    getProgressColor() {
        const start = new Date(this.taskData.additionDate.substr(0, 10));
        const end = new Date(this.taskData.deadline.substr(0, 10));
        const today = new Date();
        /*        const start = new Date('2022-01-15');
                const today = new Date('2022-02-16');
                const end = new Date('2022-02-28');*/

        const totalDays = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
        const daysElapsed = Math.floor((today.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

        if (today > end) {
            this.progressBar = 100;
            // 
        } else if (today < start) {
            this.progressBar = 0;
            // 
        } else if (today >= start && today <= end){
            this.progressBar = Math.floor(100 * daysElapsed / totalDays);
            // 
        } else {
            this.progressBar = 0;
        }

        if (this.progressBar <= 25) {
            this.barClass = 'bg-success';
            this.spanColor = '#1bc5bd';
        } else if (this.progressBar > 25 && this.progressBar <= 50) {
            this.barClass = 'bg-info';
            this.spanColor = '#8950fc';
        } else if (this.progressBar > 50 && this.progressBar <= 75) {
            this.barClass = 'bg-warning';
            this.spanColor = '#ffa800';
        } else if (this.progressBar > 75 && this.progressBar <= 100) {
            this.barClass = 'bg-danger';
            this.spanColor = '#f64e60';
        }

    }

    taskChecked(index) {
        const subTaskList = this.taskData.subtasks;
        subTaskList[index].solved = !subTaskList[index].solved;
        

        this.projectsService.updateSubtaskList(this.taskId, subTaskList).subscribe((res: any) => {
            

            let subTasksSolved = 0;
            subTaskList.forEach(subTask => {
                if (subTask.solved === true) {
                    subTasksSolved++;
                }
            });
            this.subTaskPercentage = Math.floor(subTasksSolved * 100 / subTaskList.length);

            this.apexChart.updateSeries([this.subTaskPercentage]);
            if (this.subTaskPercentage === 100) {
                this.projectsService.changeTaskERPStatus(this.taskId, 'completed').subscribe( statusRes => {
                    
                    this.taskData.status = 'completed';
                });
            } else {
                this.projectsService.changeTaskERPStatus(this.taskId, 'in progress').subscribe( statusRes => {
                    
                    this.taskData.status = 'in progress';
                });
            }
        });
    }

    taskDone() {
        if (this.taskData.status !== 'completed') {
            this.projectsService.changeTaskERPStatus(this.taskId, 'completed').subscribe( statusRes => {
                this.taskData.status = 'completed';
                if (this.taskData?.subtasks.length === 0) {
                    this.apexChart.updateSeries([100]);
                }
            });
        } else {
            this.projectsService.changeTaskERPStatus(this.taskId, 'in progress').subscribe( statusRes => {
                this.taskData.status = 'in progress';
                if (this.taskData?.subtasks.length === 0) {
                    this.apexChart.updateSeries([0]);
                }
            });
        }
    }

    openModal(modal) {
        this.modalService.open(modal, {centered: true});
    }

    ngOnDestroy() {
        this.unsubscribe.forEach(sb => sb.unsubscribe());
    }


}
